export default __webpack_public_path__ + "locales/lv/PDFFormDialog.json?hash=35b8abbca2dbd6cf90dd2290c1813f65";